import { render } from "./meeting-duration-dropdown.vue?vue&type=template&id=171cfd8a&lang=pug"
import script from "./meeting-duration-dropdown.vue?vue&type=script&lang=js"
export * from "./meeting-duration-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__